import Button from '@/components/UI/Button';
import { HookCheckboxGroup } from '@/components/UI/HookForm/Form/CheckBoxGroup';
import { userDocumentsInfos } from './constant';

const ApplicationPrerequisites = () => {
  return (
    <div className='bg-white p-6 space-y-6 rounded-md'>
      <h3 className='text-lg leading-6 font-medium text-green-500'>Welcome to the program</h3>

      <HookCheckboxGroup
        label='Please select which documents you have '
        id='userDocumentInfo'
        name='userDocumentInfo'
        orientation='vertical'
        options={userDocumentsInfos}
      />
      <div className='mt-5 flex justify-end'>
        <Button label='Next' btnStyle='primary' type='submit' />
      </div>
    </div>
  );
};

export default ApplicationPrerequisites;
